import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
	dialog: {
		maxHeight: "90vh",
		borderRadius: "lg",
	},
	body: {
		overflowY: "auto",
		flex: "1 1 auto", // allow it to grow and shrink
	},
});

export const modalTheme = defineMultiStyleConfig({
	baseStyle,
});
